import React, { Fragment, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { PuffLoader } from 'react-spinners';

import {
  checkPreviousAction,
} from 'actions/workflow';
import Header from 'components/Header';

const Application = () => {
  const workflow = useSelector((state) => state.workflow);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const key = searchParams.get('key');
    if (!key) {
      navigate('/');
    } else {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/${params.workflowtype}/${key}/checkin`,
        success: (res) => {
          if (get(res, 'data.url')) {
            navigate(res.data.url);
          }
        },
        fail: () => {
          navigate(`/applications/${params.workflowtype}/application?key=${key}`);
        },
      }));
    }
  }, [window.location.search]);

  useEffect(() => {
    const data = get(workflow, 'data');
    if (data) {
      const routeUrl = data.url;
      navigate(routeUrl);
    }
  }, []);


  return (
    <Fragment>
      <Header />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 500 }}>
        <PuffLoader color="#3989E3" size={100} />
      </div>
    </Fragment>
  );
};

export default Application;
